import { apiClient, routes, type ApiClientResponse } from 'common/services';
import { type TodoDataObject } from '../types';

export type GetTodosDataObject = TodoDataObject;

export const getTodos = async () =>
  apiClient.get<GetTodosDataObject[], ApiClientResponse<GetTodosDataObject[]>>(routes.todos.get);
